import { createFileRoute } from '@tanstack/react-router';

import { IdentityVerificationPage } from './IdentityVerificationPage';

export const Route = createFileRoute('/_protected/_consumer/identity-verification/')({
  component: IdentityVerificationPage,
});
